import { useMemo } from "react";
import RemoteResource from "../remoteResource/RemoteResource";
import useRemoteResource from "../remoteResource/useRemoteResource";
import Path, { StringMap } from "../../models/ui/Path";

import UpcomingUserAppointmentResponse from "../../models/serviceApi/UpcomingUserAppointmentResponse";
import UpcomingUserAppointmentMapper from "../../mappers/UpcomingUserAppointmentMapper";
import UpcomingUserAppointmentsList from "../../models/domain/UpcommingUserAppointmentsList";

export default function useUpcomingUserAppointments(
  query: StringMap = {},
  userProfile: any,
): RemoteResource<UpcomingUserAppointmentsList | undefined> {
  const { error, isLoading, resource, refresh } =
    useRemoteResource<UpcomingUserAppointmentResponse>(
      query !== undefined
        ? new Path(["api", "v1", "appointments", "upcoming"], query).toString()
        : null,
    );

  const mappedResource = useMemo(
    () =>
      resource
        ? new UpcomingUserAppointmentsList(
            resource?.appointments?.map((appointment) =>
              UpcomingUserAppointmentMapper.mapResponseToModel({
                appointment,
              }),
            ) || [],
            resource.status,
          )
        : undefined,
    [resource],
  );

  return {
    resource: mappedResource,
    isLoading,
    error,
    refresh,
  };
}
